export default __webpack_public_path__ + "static/media/coin.42545374.png";